import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';
import { OneNewsT, UpdateNewsRequestT } from "../api/types/news";

initDefaultSchema();

// Update Prompt

export type UpdateNewsFormT = Omit<UpdateNewsRequestT, 'newEditTime' | 'newSendTime' | 'newStatus'>
export const getUpdateNewsValues = (values?: OneNewsT['response']): UpdateNewsFormT => ({
  newText: values?.text,
  newUrl: values?.url,
});
const updateSchema: Yup.ObjectSchema<UpdateNewsFormT> = Yup.object({
  newText: Yup.string().required(),
  newUrl: Yup.string().required(),
});
export const updateNewsResolver = yupResolver(updateSchema) as Resolver<UpdateNewsFormT>;
